interface RefreshButtonProps {
  onClick: () => void
  loading?: boolean
  className?: string
  size?: 'sm' | 'md'
}

export default function RefreshButton({
  onClick,
  loading = false,
  className = '',
  size = 'sm',
}: RefreshButtonProps) {
  const sizeClasses = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5'
  const buttonClasses = size === 'sm' ? 'p-1.5' : 'p-2'

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      className={`inline-flex items-center justify-center rounded-md border border-gray-300 bg-white text-gray-500 hover:bg-gray-50 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed ${buttonClasses} ${className}`}
      title="Refresh"
    >
      <svg
        className={`${sizeClasses} ${loading ? 'animate-spin' : ''}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
    </button>
  )
}
